document.addEventListener('DOMContentLoaded', function () {
  const shareButton = document.querySelector('#shareButton');
  if (navigator.share && shareButton) {
    shareButton.classList.remove("d-none");
    shareButton.addEventListener('click', () => {
      navigator.share({
        title: 'INFO TOKIMO',
        text: shareButton.querySelector('button')?.dataset?.text || '',
      });
    });
  }
});
